import React from "react";

export default function EC_TextArea({ label, value, onChange, onFocusOut }) {
  return (
    <div className="flex h-full  rounded-xl w-[100%] ">
      <div className=" text-[13px]">{label}</div>
      <div className="w-[100%] h-full">
        <textarea
          className="w-[100%] h-full  resize-none bg-[#ffffff0b] outline-none border-[#ffffff14] border-[1px] rounded-xl text-[#f0eeff] px-[9px] py-[12px] font-normal leading-none text-[13px]"
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          onBlur={onFocusOut}
          placeholder="Enter text here" 
        />
      </div>
    </div>
  );
}
